import css from './Pill.module.scss';
// import colorVars from "components/jscolors.module.scss";

export default function Pill({
  label,
  color,
  type,
  action,
  variant = 'secondary',
  iconLeft,
  iconRight,
  style,
  size='m'
}) {
  const content = (
    <>
      {iconLeft && <i className={iconLeft} />}
      {label && <span>{label}</span>}
      {iconRight && <i className={iconRight} />}
    </>
  );

  return (
    <div
      style={style}
      onClick={action}
      className={`${css['pill']} sem--${variant}-${color} ${type} ${css[size]}`}
    >
      {content}
    </div>
  );
}
